import config from 'config';
import * as actionTypes from './actions';
let userData = localStorage.getItem('diologUserData');
let authToken = localStorage.getItem('diologAuthToken');
export const initialState = {
    isLoggedIn: userData && authToken ? true : false,
    permissions: {},
    companyList: [],
    userData: {},
    companyCreator: false,
    companyValidated: false,
    hasSubscribed: false,
    showNotValidationMessage: 0,
    showNotSubscribedMessage: 0,
    showNotSubscribedForNonCreatorMessage: 0,
    permissions: {
        canCreateEvent: 0,
        canInviteTeamMembers: 0,
        canManageQuestion: 0,
        hasAdministrativeControl: 0,
        userPermissions: [],
        teamMemberRole: ''
    },
    pagePermissions: {
        calendar: {
            hasEditPermission: false,
            hasViewPermission: false
        },
        dashboard: {
            hasEditPermission: true,
            hasViewPermission: true
        },
        faq: {
            hasEditPermission: true,
            hasViewPermission: true
        },
        questions: {
            hasEditPermission: false,
            hasViewPermission: false
        },
        'question-registry': {
            hasEditPermission: false,
            hasViewPermission: false
        },
        announcements: {
            hasEditPermission: false,
            hasViewPermission: false
        },
        'my-team': {
            hasEditPermission: false,
            hasViewPermission: false
        },
        'integrate-diolog': {
            hasEditPermission: false,
            hasViewPermission: false
        },
        'web-form': {
            hasEditPermission: false,
            hasViewPermission: false
        },
        'email-extension': {
            hasEditPermission: false,
            hasViewPermission: false
        },
        'company-details': {
            hasEditPermission: false,
            hasViewPermission: false
        },
        profile: {
            hasEditPermission: true,
            hasViewPermission: true
        },
        'company-profile': {
            hasEditPermission: true,
            hasViewPermission: true
        },
        'excutive-team': {
            hasEditPermission: false,
            hasViewPermission: false
        },
        inviteLink: {
            hasEditPermission: true,
            hasViewPermission: true
        },
        help: {
            hasEditPermission: true,
            hasViewPermission: true
        }
    }
};
const authReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setIsLoggedIn:
            return {
                ...state,
                isLoggedIn: action.isLoggedIn
            };
        case actionTypes.SET_PERMISSIONS:
            return {
                ...state,
                permissions: action.permissions
            };
        case actionTypes.SET_COMPANY_LIST:
            return {
                ...state,
                companyList: action.companyList
            };
        case actionTypes.SET_AUTHENTICATED_USER_DATA:
            return {
                ...state,
                userData: action.userData
            };
        case actionTypes.SET_COMPANY_CREATOR_FLAG:
            return {
                ...state,
                companyCreator: action.companyCreator
            };
        case actionTypes.SET_COMPANY_VALIDATED:
            return {
                ...state,
                companyValidated: action.companyValidated
            };
        case actionTypes.SET_SUBSCRIBED:
            return {
                ...state,
                hasSubscribed: action.hasSubscribed
            };
        case actionTypes.SHOW_NOT_VALIDATED:
            return {
                ...state,
                showNotValidationMessage: state.showNotValidationMessage + 1
            };
        case actionTypes.SHOW_NOT_SUBSCRIBED:
            return {
                ...state,
                showNotSubscribedMessage: state.showNotSubscribedMessage + 1
            };
        case actionTypes.SHOW_NOT_SUBSCRIBED_NON_CREATOR:
            return {
                ...state,
                showNotSubscribedForNonCreatorMessage: state.showNotSubscribedForNonCreatorMessage + 1
            };
        case actionTypes.SET_PAGE_PERMISSIONS:
            return {
                ...state,
                pagePermissions: action.pagePermissions
            };
        default:
            return state;
    }
};

export default authReducer;
